import { render } from "./RematesProximosComponent.vue?vue&type=template&id=38143168"
import script from "./RematesProximosComponent.vue?vue&type=script&lang=js"
export * from "./RematesProximosComponent.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src69468266/src/ln-campo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__